import {FilterType} from "../../shared/enums/filterType"

export enum MatchMode {
    equals = "equals",
    between = "between",
    equalsIgnoreCase = "equalsIgnoreCase",
    greater = "greater",
    less = "less",
    dateEquals = "dateEquals",
    dateLessEquals = "dateLessEquals",
    dateBetween = "dateBetween",
    isIn = "isIn",
}

class Filter {
    name: string

    value: any

    from: any

    to: any

    matchMode = MatchMode.equals

    filterType: FilterType

    enable = false

    constructor(enable: boolean) {
        this.enable = enable
    }

    public static enabled(): Filter {
        return new Filter(true)
    }

    public static isValid(value: Filter): boolean {
        if (value.enable === true) {
            return (
                !Filter.isEmptyValues(value.value) ||
                (!Filter.isEmptyValues(value.from) &&
                    !Filter.isEmptyValues(value.to))
            )
        }
        return true
    }

    public static isEmptyValues(value) {
        return (
            value === undefined ||
            value === null ||
            (typeof value === "string" && value.trim().length === 0) ||
            (Array.isArray(value) &&
                value.filter((e) => e !== undefined).length === 0)
        )
    }
}

export default Filter
